import { array, object, string } from "yup"

export default object().shape({
  emails: array()
    .of(string().email("Invalid email format"))
    .min(1, "At least one email is required")
    .required(),
})
